function Footer() {
    return (
        <footer>
            <p>{'©' + new Date().getFullYear() + ' Hibiscus Technology'}</p>
        </footer>
    );
}

export default Footer;